export default __webpack_public_path__ + "static/media/5.dcf7ec38.jpg";